import { useState, useEffect } from 'react';

let _toastCallback = null;

export const toast = {
    show(msg, type = 'info', duration = 3000) { if (_toastCallback) _toastCallback({ msg, type, duration }); },
    error(msg)   { toast.show(msg, 'error',   4000); },
    success(msg) { toast.show(msg, 'success', 2500); },
    info(msg)    { toast.show(msg, 'info',    3000); },
};

export function ToastContainer() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        _toastCallback = ({ msg, type, duration }) => {
            const id = Date.now() + Math.random();
            setItems(prev => [...prev, { id, msg, type }]);
            setTimeout(() => setItems(prev => prev.filter(t => t.id !== id)), duration);
        };
        return () => { _toastCallback = null; };
    }, []);
    if (items.length === 0) return null;
    return (
        <div className="toast-container">
            {items.map(t => (
                <div key={t.id} className={`toast-item toast-${t.type}`}>
                    {t.type === 'error'   && <span className="toast-icon">&#x2715;</span>}
                    {t.type === 'success' && <span className="toast-icon">&#x2713;</span>}
                    {t.type === 'info'    && <span className="toast-icon">&#x2139;</span>}
                    <span>{t.msg}</span>
                </div>
            ))}
        </div>
    );
}
